import { application } from "controllers/application"
import Controller0 from "controllers/account/action_log_controller"
application.register("account--action-log", Controller0)
import Controller1 from "controllers/account/edit_controller"
application.register("account--edit", Controller1)
import Controller2 from "controllers/account/privacy_controller"
application.register("account--privacy", Controller2)
import Controller3 from "controllers/account_managements/demo_controller"
application.register("account-managements--demo", Controller3)
import Controller4 from "controllers/account_managements/features_controller"
application.register("account-managements--features", Controller4)
import Controller5 from "controllers/account_managements/form_controller"
application.register("account-managements--form", Controller5)
import Controller6 from "controllers/accounts/index_controller"
application.register("accounts--index", Controller6)
import Controller7 from "controllers/accounts/shared_signup_controller"
application.register("accounts--shared-signup", Controller7)
import Controller8 from "controllers/accounts/signin_controller"
application.register("accounts--signin", Controller8)
import Controller9 from "controllers/accounts/signup_controller"
application.register("accounts--signup", Controller9)
import Controller10 from "controllers/accounts/signup_thank_you_controller"
application.register("accounts--signup-thank-you", Controller10)
import Controller11 from "controllers/accounts/statistics_controller"
application.register("accounts--statistics", Controller11)
import Controller12 from "controllers/accounts/verify_email_controller"
application.register("accounts--verify-email", Controller12)
import Controller13 from "controllers/address_book_contacts/show_list_controller"
application.register("address-book-contacts--show-list", Controller13)
import Controller14 from "controllers/agents/index_controller"
application.register("agents--index", Controller14)
import Controller15 from "controllers/aiextensions/index_controller"
application.register("aiextensions--index", Controller15)
import Controller16 from "controllers/ajax_form_controller"
application.register("ajax-form", Controller16)
import Controller17 from "controllers/application_settings/api_keys/index_controller"
application.register("application-settings--api-keys--index", Controller17)
import Controller18 from "controllers/application_settings/edit_controller"
application.register("application-settings--edit", Controller18)
import Controller19 from "controllers/apps/edit_controller"
application.register("apps--edit", Controller19)
import Controller20 from "controllers/apps/index_controller"
application.register("apps--index", Controller20)
import Controller21 from "controllers/assistants/conversation_tester_controller"
application.register("assistants--conversation-tester", Controller21)
import Controller22 from "controllers/assistants/edit_analytics_controller"
application.register("assistants--edit-analytics", Controller22)
import Controller23 from "controllers/assistants/edit_guide_controller"
application.register("assistants--edit-guide", Controller23)
import Controller24 from "controllers/assistants/edit_human_handover_controller"
application.register("assistants--edit-human-handover", Controller24)
import Controller25 from "controllers/assistants/edit_instructions_controller"
application.register("assistants--edit-instructions", Controller25)
import Controller26 from "controllers/assistants/edit_intake_form_controller"
application.register("assistants--edit-intake-form", Controller26)
import Controller27 from "controllers/assistants/edit_knowledge_base_controller"
application.register("assistants--edit-knowledge-base", Controller27)
import Controller28 from "controllers/assistants/edit_profile_controller"
application.register("assistants--edit-profile", Controller28)
import Controller29 from "controllers/assistants/edit_shell_controller"
application.register("assistants--edit-shell", Controller29)
import Controller30 from "controllers/assistants/edit_triggers_controller"
application.register("assistants--edit-triggers", Controller30)
import Controller31 from "controllers/assistants/edit_widget_controller"
application.register("assistants--edit-widget", Controller31)
import Controller32 from "controllers/audit_logs_controller"
application.register("audit-logs", Controller32)
import Controller33 from "controllers/billing_controller"
application.register("billing", Controller33)
import Controller34 from "controllers/callback_controller"
application.register("callback", Controller34)
import Controller35 from "controllers/chat/add_users_modal_controller"
application.register("chat--add-users-modal", Controller35)
import Controller36 from "controllers/chat/alert_settings_controller"
application.register("chat--alert-settings", Controller36)
import Controller37 from "controllers/chat/bans/index_controller"
application.register("chat--bans--index", Controller37)
import Controller38 from "controllers/chat/bots/create_controller"
application.register("chat--bots--create", Controller38)
import Controller39 from "controllers/chat/bots/index_controller"
application.register("chat--bots--index", Controller39)
import Controller40 from "controllers/chat/dialog_edit_controller"
application.register("chat--dialog-edit", Controller40)
import Controller41 from "controllers/chat/history_controller"
application.register("chat--history", Controller41)
import Controller42 from "controllers/chat/offline_alerts_controller"
application.register("chat--offline-alerts", Controller42)
import Controller43 from "controllers/chat/rules/index_controller"
application.register("chat--rules--index", Controller43)
import Controller44 from "controllers/confirm_controller"
application.register("confirm", Controller44)
import Controller45 from "controllers/confirm_uncheck_controller"
application.register("confirm-uncheck", Controller45)
import Controller46 from "controllers/content/edit_controller"
application.register("content--edit", Controller46)
import Controller47 from "controllers/content/index_controller"
application.register("content--index", Controller47)
import Controller48 from "controllers/content/picker_controller"
application.register("content--picker", Controller48)
import Controller49 from "controllers/content/upload_controller"
application.register("content--upload", Controller49)
import Controller50 from "controllers/custom_classes/index_controller"
application.register("custom-classes--index", Controller50)
import Controller51 from "controllers/domains_blacklists_controller"
application.register("domains-blacklists", Controller51)
import Controller52 from "controllers/history_back_controller"
application.register("history-back", Controller52)
import Controller53 from "controllers/jobs/export_controller"
application.register("jobs--export", Controller53)
import Controller54 from "controllers/jobs/import_controller"
application.register("jobs--import", Controller54)
import Controller55 from "controllers/layout/embedded_content_controller"
application.register("layout--embedded-content", Controller55)
import Controller56 from "controllers/layout/session_health_controller"
application.register("layout--session-health", Controller56)
import Controller57 from "controllers/mailing_controller"
application.register("mailing", Controller57)
import Controller58 from "controllers/notifier/queue_controller"
application.register("notifier--queue", Controller58)
import Controller59 from "controllers/notifier/send_controller"
application.register("notifier--send", Controller59)
import Controller60 from "controllers/notifier/settings_controller"
application.register("notifier--settings", Controller60)
import Controller61 from "controllers/notifier/subscription_controller"
application.register("notifier--subscription", Controller61)
import Controller62 from "controllers/onboarding_stats_controller"
application.register("onboarding-stats", Controller62)
import Controller63 from "controllers/public_billing_controller"
application.register("public-billing", Controller63)
import Controller64 from "controllers/service_notifications_controller"
application.register("service-notifications", Controller64)
import Controller65 from "controllers/stats/accounts_total_controller"
application.register("stats--accounts-total", Controller65)
import Controller66 from "controllers/stats/api_controller"
application.register("stats--api", Controller66)
import Controller67 from "controllers/stats/entity_controller"
application.register("stats--entity", Controller67)
import Controller68 from "controllers/stats/not_active_apps_controller"
application.register("stats--not-active-apps", Controller68)
import Controller69 from "controllers/stats/resources_controller"
application.register("stats--resources", Controller69)
import Controller70 from "controllers/submit_controller"
application.register("submit", Controller70)
import Controller71 from "controllers/users/chat_connections_table_controller"
application.register("users--chat-connections-table", Controller71)
import Controller72 from "controllers/users/edit_address_books_controller"
application.register("users--edit-address-books", Controller72)
import Controller73 from "controllers/users/edit_form_controller"
application.register("users--edit-form", Controller73)
import Controller74 from "controllers/users/email_settings_controller"
application.register("users--email-settings", Controller74)
import Controller75 from "controllers/users/list_controller"
application.register("users--list", Controller75)
import Controller76 from "controllers/users/new_form_controller"
application.register("users--new-form", Controller76)
import Controller77 from "controllers/users/subscriptions_table_controller"
application.register("users--subscriptions-table", Controller77)
export { application }